<template>
	<div class="pa-3">
		<v-row justify="end" no-gutters>
			<v-menu
				v-model="statusShow"
				offset-y
				:close-on-content-click="false"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-btn x-small icon  v-bind="attrs" v-on="on" :disabled="loading">
						<v-icon color="rgba(25, 42, 62, 0.7)">mdi-pencil</v-icon>
					</v-btn>
				</template>
				<v-card width="300">
					<v-row no-gutters class="pa-3">
						<v-col cols="12">
							<div class="status-text">Assign statuses to each tab</div>
						</v-col>
						<v-col cols="12" class="my-1">
							<div class="status-text">To Do</div>
							<v-select
								v-model="upcoming_statuses"
								:color="color_main"
								:items="task_statuses"
								item-text="desc"
								item-value="id"
								item-color="success"
								item-disabled="disable"
								outlined
								dense
								hide-details
								return-object
								multiple
							>
							</v-select>
						</v-col>
						<v-col cols="12" class="my-1">
							<div class="status-text">Overdue</div>
							<v-select
								v-model="overdue_statuses"
								:color="color_main"
								:items="task_statuses"
								item-text="desc"
								item-value="id"
								item-color="success"
								item-disabled="disable"
								outlined
								dense
								hide-details
								return-object
								multiple
							>
							</v-select>
						</v-col>
						<v-col cols="12" class="my-1">
							<div class="status-text">Urgent</div>
							<v-select
								v-model="urgent_statuses"
								:color="color_main"
								:items="task_statuses"
								item-text="desc"
								item-value="id"
								item-color="success"
								item-disabled="disable"
								outlined
								dense
								hide-details
								return-object
								multiple
							>
							</v-select>
						</v-col>
						<v-col cols="12" class="my-1">
							<div class="status-text">Completed</div>
							<v-select
								v-model="completed_statuses"
								:color="color_main"
								:items="task_statuses"
								item-text="desc"
								item-value="id"
								item-color="success"
								item-disabled="disable"
								outlined
								dense
								hide-details
								return-object
								multiple
							>
							</v-select>
						</v-col>
					</v-row>
				</v-card>
			</v-menu>
			<v-menu
				v-model="categoryShow"
				offset-y
				:close-on-content-click="false"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon x-small class="ml-2" v-bind="attrs" v-on="on" :disabled="loading">
						<ColumnsTable style="width: 16px; height: 16px" :color="loading ? 'rgba(0, 0, 0, 0.26)' :'rgba(25, 42, 62, 0.7)' "/>
					</v-btn>
				</template>
				<v-card width="auto">
					<v-simple-table>
						<template v-slot:default>
							<v-draggable :list="category_items" tag="tbody">
								<tr v-for="item in category_items" :key="item.name">
									<v-row no-gutters :align="`center`" class="pr-2">
										<Drag class="mr-1 mt-2" width="24" height="24" :color="color_main"/>
										<v-checkbox
											v-model="item.selectd"
											@click.native.stop
											:color="color_main"
											dense
											hide-details
										>
											<template v-slot:label>
												<div class="status-text" :style="`color: ${color_main}`">{{ item.text }}</div>
											</template>
										</v-checkbox>
									</v-row>
								</tr>
							</v-draggable>
						</template>
					</v-simple-table>
				</v-card>
			</v-menu>
		</v-row>
		<v-alert
			v-if="error_msg.length !== 0"
			type="error"
			dense
		>
			{{ error_msg }}
		</v-alert>
		<div v-if="error_msg.length === 0 && loading">
			<v-progress-linear
				indeterminate
				color="#EAEAEA"
				background-color="#DADADA"
				rounded
				width="100px"
				height="15px"
				style="margin: 5px"
			></v-progress-linear>
			<v-progress-linear
				indeterminate
				color="#EAEAEA"
				background-color="#DADADA"
				rounded
				width="100px"
				height="15px"
				style="margin: 5px"
			></v-progress-linear>
		</div>
		<v-row no-gutters v-if="!loading">
			<v-tabs
				v-model="tab"
				:color="color_main"
				:show-arrows="$vuetify.breakpoint.smAndDown"
				grow
				center-active
				hide-slider
				active-class="active-tab"
			>
				<v-tab
					v-for="item in tab_items"
					:key="item.key"
					class="text-capitalize"
				>
					{{ item.text }}
					<span v-if="item.count > 0">&nbsp;({{ item.count }})</span>
				</v-tab>
			</v-tabs>
			<v-tabs-items v-model="tab" style="width: 100%;" >
				<v-tab-item
					v-for="item in tab_items"
					:key="`content_${item.key}`"
				>
					<v-card flat class="rounded-t-0" style="border-top: thin solid rgba(0, 0, 0, 0.12)">
						<v-data-table
							:headers="category_items.filter(c => { return c.selectd === true })"
							:items="taskItems"
							:page.sync="page"
							:items-per-page="countPerpage"
							hide-default-footer
							@click:row="onRowClick($event)"
							@update:options="onSortBy($event, item.key)"
						>
							<template v-slot:item.job="{ item }">			
								<span>{{ item.job.desc }}</span>
							</template>
							<template v-slot:item.client="{ item }">			
								<span>{{ item.client.name }}</span>
							</template>
							<template v-slot:item.timesheet="{ item }">			
								<v-btn
									x-small
									color="#81CC00"
									fab
									depressed
									:disabled="item.timesheet"
								>
									<TimeSheet color="#FFFFFF" width="20" height="20" @click="task_id = item.id"/>
								</v-btn>
							</template>
							<template v-slot:item.start_date="{ item }">
								<span>{{ formatDate(item.start_date) }}</span>		
							</template>
							<template v-slot:item.end_date="{ item }">
								<span>{{ formatDate(item.end_date) }}</span>		
							</template>
							<template v-slot:item.status="{ item }">
								<v-select
									:value="item.status"
									:color="color_main"
									:menu-props="{ bottom: true, offsetY: true}"
									:items="getStatuses(item.id)"
									item-text="desc"
									item-value="id"
									item-color="success"
									item-disabled="disable"
									:background-color="item.job_valid && privileges.includes(privilege_tr) ? item.status.color: 'rgba(0,0,0,.12)'"
									dense
									outlined
									hide-details
									return-object
									:disabled="!item.job_valid || !privileges.includes(privilege_tr)"
									@click.stop
									@change="onStatusChange($event, item.id)"
								>
									<template v-slot:append>
										<v-icon :style="`color: ${item.job_valid && privileges.includes(privilege_tr) ? formatColor(item.status.color):'rgba(0,0,0,.26)'}`">mdi-chevron-down</v-icon>
									</template>
									<template v-slot:selection="{ item, disabled }">
										<span :style="`color: ${!disabled ? formatColor(item.color):'rgba(0,0,0,.26)'}`">{{ item.desc}}</span>
									</template>
									<template v-slot:item="{item, on}">
										<v-list-item v-on="on" dense>
											<v-badge
												:color="item.disable ? 'rgba(0,0,0,.26)': item.color"
												left
												inline
											>
												<span class="ml-1" :style="`color:${item.disable ? 'rgba(0,0,0,.16)':''}`">{{ item.desc }}</span>
											</v-badge>					
										</v-list-item>
									</template>
								</v-select>
							</template>
							<template v-slot:footer>
								<div class="pagination" v-if="taskItems.length >= 5">
									<v-pagination
										v-model="page"
										:color="color_main"
										:length="getPaginationTotal()"
										:total-visible="$vuetify.breakpoint.xs ? 3: 5"
										circle
									></v-pagination>
									<template v-if="false">
										<div class="pagination-text">show</div>
										<div class="pagination-text-page">{{ countPerpage }} / page</div>
										<v-menu offset-y>
											<template v-slot:activator="{ on, attrs }">
												<div v-bind="attrs" v-on="on"><Down class="down"/></div>
											</template>
											<v-list>
												<v-list-item-title v-for="(pageOption, index) in pageOptions" :key="index" class="option-text" @click="onClickOption(pageOption)">
													{{pageOption}}
												</v-list-item-title>
											</v-list>
										</v-menu>
									</template>
								</div>
							</template>
						</v-data-table>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-row>
		<v-dialog
			v-if="task_detail_visible"
			v-model="task_detail_visible"
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<TaskDetail
				:color="'#81CC00'"
				:task="task_detail_item"
				:isPrivilege="privileges.includes(privilege_tr)"
				@find-ts="find_timesheet_id = $event"
				@task-copy="onDuplicateMenuItem($event)"
				@task-sub="onCreateSubTask($event)"
				@task-close="onCloseTaskDetail()"
			/>
		</v-dialog>
		<ListTimesheetDialog
			v-if="find_timesheet_id !== 0"
			:visible="find_timesheet_id !== 0"
			:maxWidth="$vuetify.breakpoint.width * 0.85"
			:taskId="find_timesheet_id"
			@close="find_timesheet_id = 0"
			@openTs="timesheet_detail_item = $event; timesheet_detail_visible = true"
		/>
		<v-dialog
			v-if="timesheet_detail_visible"
			v-model="timesheet_detail_visible "
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<EditTimesheet
				:editItem="timesheet_detail_item"
				:isAddTimesheet="false"
				:isLogTimesheet="true"
				@cancel-timesheet="timesheet_detail_item = null; timesheet_detail_visible = false"
			/>
		</v-dialog>
		<v-dialog
			v-if="task_create_visible"
			v-model="task_create_visible"
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs : width"
		>
			<TaskCreation 
				:color="'#81CC00'"
				:taskDetail="task_detail_item"
				:isSubTaskCreation="isSubTaskCreation"
				:isDuplication="isDuplication"
				@close="onTaskClose()"
			/>
		</v-dialog>
		<LogTimesheet v-if="task_id !== 0" :visible="task_id !== 0" :taskId="task_id" @close="task_id = 0"/>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
		/>
	</div>
</template>

<script>
import ColumnsTable from "@/components/icons/columns_table";
import Drag from "@/components/icons/drag";
import TimeSheet from "@/components/icons/timesheet";
import Down from '@/components/icons/down';
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import LogTimesheet from "@/components/tasks/task_timesheet";
import TaskDetail from "@/views/tasks/edit_task.vue";
import TaskCreation from "@/views/tasks/new_task.vue";
import ListTimesheetDialog from "@/views/timesheets/list_timesheet_dialog.vue";
import EditTimesheet from "@/views/timesheets/new_timesheet.vue";

import { colorContrastChecker } from '@/common/colorChecker.js';
import config from '@/config.js';
import moment from 'moment';

/** 0 = you, 1 = your team, 2 = anyone, 3 = unassigned */
const CURRENT_USER = 0;

/** 0 = today, 1 = next 7 days, 2 = date range */
const DATE_RANGE_NEXT = 1;
const DATE_RANGE = 2;

const COLOR_MAIN = '#CA66D2';
const ACTIVE_TYPE = 2;
const STUCK_TYPE = 4;
const TAB_ITEMS = [
	{
		key: 'upcoming',
		text: 'To Do',
		count: 0,
		sort: {
			name: 'end_date',
			by: true /** true => sort by newest */
		}
	},
	{
		key: 'overdue',
		text: 'Overdue',
		count: 0,
		sort: {
			name: 'end_date',
			by: true /** true => sort by newest */
		}
	},
	{
		key: 'urgent',
		text: 'Urgent',
		count: 0,
		sort: {
			name: 'end_date',
			by: true /** true => sort by newest */
		}
	},
	{
		key: 'completed',
		text: 'Completed',
		count: 0,
		sort: {
			name: 'end_date',
			by: true /** true => sort by newest */
		}
	}
];
const CATEGORY_ITEMS = [
	{
		text: 'Tasks',
		value: 'title',
		selectd: true,
		sortable: false,
		order: 0
	},
	{
		text: 'Job',
		value: 'job',
		selectd: true,
		sortable: false,
		order: 1
	},
	{
		text: 'Client',
		value: 'client',
		selectd: true,
		sortable: false,
		order: 2
	},
	{
		text: 'Timesheet',
		value: 'timesheet',
		selectd: true,
		sortable: false,
		order: 3
	},
	{
		text: 'Start date',
		value: 'start_date',
		selectd: true,
		sortable: true,
		order: 4
	},
	{
		text: 'Due',
		value: 'end_date',
		selectd: true,
		sortable: true,
		order: 5
	},
	{
		text: 'Status',
		value: 'status',
		selectd: true,
		sortable: false,
		order: 6
	},
];

/** Restrict entry against complete, cancelled or dead jobs */
const JOr = 'JOr';
/* the user will be able to create and amend tasks */
const TR = 'TR';

export default {
	name: 'Schedule',
	components: {
		ColumnsTable,
		Drag,
		TimeSheet,
		Down,
		DialogNotice,
		LogTimesheet,
		TaskDetail,
		TaskCreation,
		ListTimesheetDialog,
		EditTimesheet
	},
	data() {
		this.privilege_tr = TR;
		this.color_main = COLOR_MAIN;
		this.status_completed_type = config.status_completed_type;
		this.width = '800';

		return {
			error_msg: '',
			loading: false,
			settings: [],
			
			tab: null,
			tab_items: TAB_ITEMS,

			statusShow: false,
			task_statuses: [],
			upcoming_statuses: [],
			overdue_statuses: [],
			urgent_statuses: [],
			completed_statuses: [],

			upcoming_statuses_origin: [],
			overdue_statuses_origin: [],
			urgent_statuses_origin: [],
			completed_statuses_origin: [],

			categoryShow: false,
			category_items: this.initCategoryItems(),

			page: 1,
			countPerpage: 10,
			pageOptions: [5, 10, 20, 50, 100],

			job_invalid_status_ids: [],
			task_id: 0,
			task_detail_item: null,
			task_detail_visible: false,

			find_timesheet_id: 0,
			timesheet_detail_visible: false,
			timesheet_detail_item: null,

			isDuplication: false,
			isSubTaskCreation: false,
			task_create_visible: false,

			upcoming_tasks: [],
			overdue_tasks: [],
			urgent_tasks: [],
			completed_tasks: [],

			visible_notice: false,
			notice_text: [],
			tid: null,
		}
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	async created() {
		await this.getSettings();
		await this.getTaskStatuses();
		await this.getJobStatusIds();

		TAB_ITEMS.forEach(tab => {
			this.listTasks(tab.key);
		});
	},
	watch: {
		statusShow(newVal) {
			if (newVal === false) {
				const isActive = this._isActive();

				if (isActive) {
					TAB_ITEMS.forEach(tab => {
						this.listTasks(tab.key);
					});

					const win_setup_obj = this.getSettingParams();
					const win_setup_str = JSON.stringify(win_setup_obj);

					this.updateSettings(win_setup_str);
				}
			}
		},
		categoryShow(newVal) {
			if (newVal === false) {
				const win_setup_obj = this.getSettingParams();
				const win_setup_str = JSON.stringify(win_setup_obj);

				this.updateSettings(win_setup_str);
			}
		},
		category_items() {
			this.category_items.forEach((c, index)=> {
				c.order = index;
			});
		}
	},
	computed: {
		userId() {
			return this.$store.state.user && this.$store.state.user.id;
		},
		privileges () {
			return this.$store.state.privileges;
		},
		recordingTaskId() {
			return this.$store.state.recording.task_id;
		},
		completedJobPrivilege() {
			let isCompletedJobTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(JOr)) {
				isCompletedJobTmp = true;
			}
			return isCompletedJobTmp
		},
		taskItems() {
			let taskitems_tmp = [];
			
			let taskitems_arr = [];
			if (this.tab === 0) {
				taskitems_arr = this.upcoming_tasks;
			}
			if (this.tab === 1) {
				taskitems_arr = this.overdue_tasks;
			}
			if (this.tab === 2) {
				taskitems_arr = this.urgent_tasks;
			}if (this.tab === 3) {
				taskitems_arr = this.completed_tasks;
			}

			if (taskitems_arr.length !== 0) {
				taskitems_arr.forEach(task => {
					const obj = task;

					this.category_items.forEach(category => {
						if (!category.selectd) return;
						
						if(category.value === 'end_date') {
							const date = !task.end_date || task.end_date.length === 0 ? '': moment(task.end_date, ['Do MMM YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD');
							obj[`${category.value}`] = date; 
						} else if (category.value === 'start_date') {
							const date = !task.start_date || task.start_date.length === 0 ? '': moment(task.start_date, ['Do MMM YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD');
							obj[`${category.value}`] = date; 
						} else if(category.value === 'timesheet') {
							const disabled = task.status.type === this.status_completed_type || !task.job_valid;
							obj[`${category.value}`] = disabled; 
						} else {
							obj[`${category.value}`] = task[`${category.value}`];
						}
					});

					obj['job_valid'] = task.job_valid;

					taskitems_tmp.push(obj);
				});
			}
			return taskitems_tmp;
		}
	},
	methods: {
		onSortBy(options, key) {
			if (options.sortBy.length !== 0 && options.sortDesc.length !== 0) {
				const sort_name = options.sortBy[0];
				const sort_by = options.sortDesc[0];
				this.tab_items.forEach(t => {
					if (t.key === key) {
						t.sort.name = sort_name;
						t.sort.by = sort_by;
					}
				});
			}
		},
		initCategoryItems() {
			CATEGORY_ITEMS.forEach(c => {
				if (c.value === 'start_date' || c.value === 'end_date') {
					c.sortable = this.$vuetify.breakpoint.smAndDown ? false : true;
				}
			});

			return CATEGORY_ITEMS;
		},
		async getSettings() {
			this.loading = true;
			const usid = this.userId;
			const winname_tmp = this.$route.name;
			const winname = config.win_name[`${winname_tmp}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.settings = data;
						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		async getTaskStatuses() {
			this.loading = true;
			const url = '/api/tasks/meta';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, meta, reason } = json;
					if (status == "OK") {
						this.task_statuses = meta.statusses;
						const origin_status = meta.statusses;
						
						if (this.settings.length === 0) {
							// init Tab Status
							this.upcoming_statuses = origin_status.filter(t => { return t.type === ACTIVE_TYPE });
							this.upcoming_statuses_origin = origin_status.filter(t => { return t.type === ACTIVE_TYPE });

							this.overdue_statuses = origin_status.filter(t => { return t.type === ACTIVE_TYPE });
							this.overdue_statuses_origin = origin_status.filter(t => { return t.type === ACTIVE_TYPE });

							this.urgent_statuses = origin_status.filter(t => { return t.type === STUCK_TYPE });
							this.urgent_statuses_origin = origin_status.filter(t => { return t.type === STUCK_TYPE });

							this.completed_statuses = origin_status.filter(t => { return t.type === config.status_completed_type });
							this.completed_statuses_origin = origin_status.filter(t => { return t.type === config.status_completed_type });

						} else {
							if (this.settings.length !== 0) {
								const current_settings = this.settings.filter(d => { return d.user_id === this.userId });
								const settings_winname = current_settings[0].window_name;
								const settings_windata_json = current_settings[0].windata_json;

								const winname_tmp = this.$route.name;
								const winname = config.win_name[`${winname_tmp}`];

								if (settings_winname === winname) {
									const windata = JSON.parse(settings_windata_json);
									// init statuses for 4tabs
									this.upcoming_statuses = origin_status.filter(t => { return windata.upcoming.includes(t.id) });
									this.upcoming_statuses_origin = origin_status.filter(t => { return windata.upcoming.includes(t.id) });

									this.overdue_statuses = origin_status.filter(t => { return windata.overdue.includes(t.id) });
									this.overdue_statuses_origin = origin_status.filter(t => { return windata.overdue.includes(t.id) });

									this.urgent_statuses = origin_status.filter(t => { return windata.urgent.includes(t.id) });
									this.urgent_statuses_origin = origin_status.filter(t => { return windata.urgent.includes(t.id) });

									this.completed_statuses = origin_status.filter(t => { return windata.completed.includes(t.id) });
									this.completed_statuses_origin = origin_status.filter(t => { return windata.completed.includes(t.id) });

									// init category
									const category = windata.category;
									this.category_items.forEach(c => {
										const category_item = category.filter(category_item => { return category_item.value === c.value });
										if (category_item[0]) {
											c.order = category_item[0].order;
											c.selectd = category_item[0].selectd;
										}
									});

									this.category_items.sort((a, b) => { return a.order - b.order });
								}
							}
						}

						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		async getJobStatusIds() {
			this.loading = true;
			const url = '/api/jobs/meta';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const statuses_arr = data.substatusses;
						const job_invalid_statusses = statuses_arr.filter(s => { return !config.job_status_group_nomal.includes(s.group) });
						this.job_invalid_status_ids = job_invalid_statusses.map(s => { return s.id });

						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.userId;
			const winname_tmp = this.$route.name;
			const winname = config.win_name[`${winname_tmp}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			axios
				.post(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status !== "OK") {
						console.log('error_message:', reason);
					}
				})
				.catch((e) => {
					console.log('error_message:', e.message);
				});
		},
		listTasks(key) {
			this.loading = true;

			const params = this.getParams(key);

			let url = "/api/tasks";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status == "OK") {
						data.forEach(d => {
							if (d.job) {
								d.job['desc'] = `${d.job.code} - ${d.job.name}`;
							}
						});

						this.tab_items.forEach(t => {
							if (t.key === key) {
								t.count = data.length;

								const sort_name = t.sort.name;
								
								// sort by Due date, most recent first.
								data.sort((a, b) => {
									const a_tmp = moment(a[`${sort_name}`], ['Do MMM YYYY', 'YYYY-MM-DD']);
									const b_tmp = moment(b[`${sort_name}`], ['Do MMM YYYY', 'YYYY-MM-DD']);
									return t.sort.by ? b_tmp - a_tmp : a_tmp - b_tmp;
								});
							}
						});

						if (this.completedJobPrivilege) {
							data.forEach(d => {
								if (this.job_invalid_status_ids.includes(d.job_status.id)) {
									d['job_valid'] = false;
								} else {
									d['job_valid'] = true;
								}
							});						
						} else {
							data.forEach(d => {
								d['job_valid'] = true;
							});
						}

						// upcoming
						if (key === TAB_ITEMS[0].key) {
							this.upcoming_tasks = data;
						}
						// overdue
						if (key === TAB_ITEMS[1].key) {
							this.overdue_tasks = data;
						}
						// urgent
						if (key === TAB_ITEMS[2].key) {
							this.urgent_tasks = data;
						}
						// completed
						if (key === TAB_ITEMS[3].key) {
							this.completed_tasks = data;
						}
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				}).finally(() => {
					this.loading = false;
				});
		},
		getParams(key) {
			const params = [];

			// upcoming
			if (key === TAB_ITEMS[0].key) {
				params.push("assign_mode=" + CURRENT_USER);

				params.push("date_mode=" + DATE_RANGE_NEXT);

				const statuses_arr = this.upcoming_statuses.map(s => { return s.id });
				params.push("statusses=" + statuses_arr.join());
			}

			// overdue
			if (key === TAB_ITEMS[1].key) {
				params.push("assign_mode=" + CURRENT_USER);
				
				params.push("date_mode=" + DATE_RANGE);
				params.push("start_date=" + moment().subtract(7, 'days').format('YYYY-MM-DD'));
				params.push("end_date=" + moment().format('YYYY-MM-DD'));

				const statuses_arr = this.overdue_statuses.map(s => { return s.id });
				params.push("statusses=" + statuses_arr.join());
			}

			// urgent
			if (key === TAB_ITEMS[2].key) {
				params.push("assign_mode=" + CURRENT_USER);

				params.push("date_mode=" + DATE_RANGE);
				params.push("start_date=" + moment().subtract(1, 'months').format('YYYY-MM-DD'));
				params.push("end_date=" + moment().format('YYYY-MM-DD'));

				const statuses_arr = this.urgent_statuses.map(s => { return s.id });
				params.push("statusses=" + statuses_arr.join());
			}

			// completed
			if (key === TAB_ITEMS[3].key) {
				params.push("assign_mode=" + CURRENT_USER);

				params.push("date_mode=" + DATE_RANGE);
				params.push("start_date=" + moment().subtract(7, 'days').format('YYYY-MM-DD'));
				params.push("end_date=" + moment().format('YYYY-MM-DD'));

				const statuses_arr = this.completed_statuses.map(s => { return s.id });
				params.push("statusses=" + statuses_arr.join());
			}

			return params;
		},
		getStatuses(task_id) {
			const statuses_tmp = JSON.parse(JSON.stringify(this.task_statuses));
			statuses_tmp.forEach(s => {
				if (this.recordingTaskId === task_id && s.type === config.status_completed_type) {
					s['disable'] = true;
				} else {
					s['disable'] = false;
				}
			});
			return statuses_tmp;
		},
		getSettingParams() {
			const upcoming = this.upcoming_statuses.map(s => { return s.id });
			const overdue = this.overdue_statuses.map(s => { return s.id });
			const urgent = this.urgent_statuses.map(s => { return s.id });
			const completed = this.completed_statuses.map(s => { return s.id });

			const category_tmp = [];
			this.category_items.forEach(c => {
				const obj = {
					order: c.order,
					value: c.value,
					selectd: c.selectd
				};
				category_tmp.push(obj);
			});

			const win_setup_obj = {
				upcoming: upcoming,
				overdue: overdue,
				urgent: urgent,
				completed: completed,
				category: category_tmp
			};

			return win_setup_obj;
		},
		onRowClick(task) {
			this.task_detail_item = task;
			this.task_detail_visible = true;
		},
		onCloseTaskDetail() {
			this.task_detail_item = null;
			this.task_detail_visible = false;

			TAB_ITEMS.forEach(tab => {
				this.listTasks(tab.key);
			});
		},
		onTaskClose() {
			this.task_detail_item = null;
			this.isDuplication = false;
			this.isSubTaskCreation = false;
			this.task_create_visible = false;
		},
		onStatusChange(status, task_id) {
			this._updateTaskStatus(task_id, status.id);
		},
		formatDate(date) {
			if(!date) return null;

			return date.length === 0 ? '' : moment(date, ['Do MMM YYYY', 'YYYY-MM-DD']).format('DD MMM YYYY');
		},
		formatColor(background_color) {
			const color_res = colorContrastChecker(background_color);
			return `${color_res}`
		},
		getPaginationTotal() {
			return Math.ceil(this.taskItems.length / this.countPerpage);
		},
		onClickOption(option) {
			this.countPerpage = option;
		},
		onDuplicateMenuItem(task) {
			this.task_detail_item = task;
			this.isDuplication = true;
			this.task_create_visible = true;

			this.task_detail_visible = false;
		},
		onCreateSubTask(task) {
			this.task_detail_item = task;
			this.isSubTaskCreation = true;
			this.task_create_visible = true;

			this.task_detail_visible = false;
		},
		async _updateTaskStatus(task_id, status_id) {
			const params = [];
			params.push('status_id=' + status_id);

			let url = `/api/tasks/${task_id}/set_status`;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}
			
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, reason } = json;

					if (status == "OK") {
						this.notice_text.push('Status has been changed successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						TAB_ITEMS.forEach(tab => {
							this.listTasks(tab.key);
						});
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
		},
		_isActive() {
			let active_tmp = false;

			const upcoming_tmp = this._compare(this.upcoming_statuses, this.upcoming_statuses_origin);
			const overdue_tmp = this._compare(this.overdue_statuses, this.overdue_statuses_origin);
			const urgent_tmp = this._compare(this.urgent_statuses, this.urgent_statuses_origin);
			const completed_tmp = this._compare(this.completed_statuses, this.completed_statuses_origin);

			if (upcoming_tmp || overdue_tmp || urgent_tmp || completed_tmp) {
				active_tmp = true;
			}

			return active_tmp;
		},
		_compare(array, array_origin) {
			let is_same = false;

			if (array.length !== array_origin.length) {
				is_same = true;
			} else {
				const A = array.map(u => { return u.id });
				const B = array_origin.map(u => { return u.id });

				A.sort((a, b ) => { return a - b });
				B.sort((a, b ) => { return a - b });

				const A_str = A.join();
				const B_str = B.join();

				if (A_str !== B_str) {
					is_same = true;
				}
			}

			return is_same;
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
		},	
	}
}
</script>

<style lang="scss" scoped>
.active-tab {
	background-color: #E8EAEC;
}
.status-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
}
.header-th {
	height: 48px;
	// background: #FAFAFA;
	border-top: 1px solid rgba(0, 0, 0, 0.12);
	border-bottom: 1px solid rgba(0, 0, 0, 0.12);

	&:hover {
		background: #EAEAEA;
	}
}
.header-item {
	display: flex;
  flex-flow: row nowrap;
	justify-content: space-between;
  align-items: center;
}
.header-item-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 20px;
	color: #192A3E;
	// white-space: nowrap;
	// text-overflow: ellipsis;
}
.header-th:hover .icon {
	visibility: visible; 
}
.icon {
	visibility: hidden;
	width: 14px;
  height: 14px;
	&:hover {
		cursor: pointer;
	}
}
.pagination {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	// background-color: rgba(25, 42, 62, 0.1);
	.pagination-text {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 13px;
		line-height: 16px;
		color: rgba(25, 42, 62, 0.5);
	}
	.pagination-text-page {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 13px;
		line-height: 16px;
		color: #192A3E;
		margin: 0 8px;
	}
	.down {
		width: 12px;
		height: 12px;
		margin-top: 10px;
		&:hover {
			cursor: pointer;
		}
	}
}

.table-wrap {
  height: 80%;
  overflow: auto;
}
.table-container {
  height: 99%;
}
::v-deep {
	.option-text {
		margin: 0 4px;
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 13px;
		color: #192A3E;
		&:hover {
			cursor: pointer;
		}
	}
	.v-pagination__navigation {
		width: 20px;
		height: 20px;
	}
	.v-pagination__item {
		min-width: 26px;
		height: 26px;
	}
}
</style>
